<template>
  <div>

    <!-- .hero -->
    <section class="hero has-background-primary">

      <div class="hero-body">

        <div class="container">
          <router-link :to="{ name: 'hub'}">
            <h1 class="title has-text-white">
              RocketSchool
            </h1>
            <h2 class="subtitle">
              Learning is not a rocket science
            </h2>
          </router-link>
        </div>

      </div>
    </section>
    <!-- /.hero -->
    <router-view></router-view>

  </div>
</template>

<script>
  export default {
    name: "AppContainer"
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/AppContainer.vue